import { BILLING_CYCLE, BILLING_CYCLE_TYPE, BILLING_PERIOD } from './constants'
import { getDate, getShortDate } from '../../utils/dateTime'
import { PRODUCT_NAMES_LIST } from '../../common/constants/ProductConstants'
import iconSubscriptionExpired from '../../svg/iconSubscriptionExpired.svg'
import IconActiveUntil from '../../svg/iconActiveUntil.svg'
import IconDisabledRecurring from '../../svg/iconDisabledRecurring.svg'
import { API__PAYMENTS } from 'api'
import AnalyticsMonitor from '../../common/services/AnalyticsMonitor'

const isPriceType = type => type === BILLING_PERIOD.month || type === BILLING_PERIOD.annual
const isPriceName = name =>
    name === PRODUCT_NAMES_LIST.Free ||
    name === PRODUCT_NAMES_LIST.Starter ||
    name === PRODUCT_NAMES_LIST.Professional ||
    name === PRODUCT_NAMES_LIST.Enterprise
export const isPayload = location =>
    location.state &&
    location.state.payload &&
    isPriceType(location.state.payload.priceType) &&
    isPriceName(location.state.payload.priceName)

export const calculateFormattedExpirationDate = date => (BILLING_CYCLE.year ? getDate(date) : getShortDate(date))

export const getFormattedPrice = (price, currency) => {
    if (currency === 'USD') return `$${price.toFixed(2)}`
    else if (currency === 'RUB') return `${price.toFixed(2)} ₽`
    return null
}

export function convertToStatus(expired, t) {
    return expired ? t('Expired') : t('Active')
}

export function getSubscriptionIcon(recurringEnabled, expired) {
    if (expired) return iconSubscriptionExpired
    return recurringEnabled ? IconActiveUntil : IconDisabledRecurring
}

export function formatExpirationDate(billingCycleValue, expirationDate) {
    return billingCycleValue === BILLING_CYCLE.year ? getDate(expirationDate) : getShortDate(expirationDate)
}

export function isExpired(expirationDate) {
    return expirationDate < Date.now()
}

export function formatBillingCycle(billingCycleType, t) {
    switch (billingCycleType) {
        case BILLING_CYCLE_TYPE.year:
            return t('Yearly')
        case BILLING_CYCLE_TYPE.month:
            return t('Monthly')
        case BILLING_CYCLE_TYPE.day:
            return t('Daily')
    }
}

export const openPaymentPage = async (productCode, isUpgrade) => {
    AnalyticsMonitor.track('Buy process initiated', {
        upgrade: isUpgrade,
        selectedProductCode: productCode,
    })
    const paymentLink = await API__PAYMENTS.GET_PAYMENT_LINK({ productCode })
    window.open(paymentLink.toString())
}
